<div class="validationTooltip" role="tooltip">
    @let contentErrors = listingValidationService.contentErrors();
    @let contentWarnings = listingValidationService.contentWarnings();
    @let visualErrors = listingValidationService.visualErrors();
    @let visualWarnings = listingValidationService.visualWarnings();
    @let contentHasIssues = contentErrors.length > 0 || contentWarnings.length > 0;
    @let visualsHasIssues = visualErrors.length > 0 || visualWarnings.length > 0;

    <div class="tooltipHeader">
        <span class="tooltipTitle">{{ 'listing.validationIssues.label' | translate }}</span>
        <div class="summaryPills">
            <span class="pillSummary" [class.error]="contentHasIssues" [class.empty]="!contentHasIssues">
                <i class="fas fa-file-lines" aria-hidden="true"></i>
                {{ 'listing.validationIssues.categoryContent' | translate }}&nbsp;·&nbsp;<strong>{{
                    contentErrors.length + contentWarnings.length
                }}</strong>
            </span>
            <span class="pillSummary" [class.error]="visualsHasIssues" [class.empty]="!visualsHasIssues">
                <i class="fas fa-image" aria-hidden="true"></i>
                {{ 'listing.validationIssues.categoryVisuals' | translate }}&nbsp;·&nbsp;<strong>{{
                    visualErrors.length + visualWarnings.length
                }}</strong>
            </span>
        </div>
    </div>

    <div class="tooltipScrollBody">
        @if (contentHasIssues) {
            <div class="categorySection">
                <div class="categoryHeader">
                    <i class="fas fa-file-lines" aria-hidden="true"></i>
                    <span>{{ 'listing.validationIssues.categoryContent' | translate }}</span>
                    @if (contentErrors.length > 0) {
                        <span class="badgeCount error">{{ contentErrors.length }}</span>
                    }
                    @if (contentWarnings.length > 0) {
                        <span class="badgeCount warning">{{ contentWarnings.length }}</span>
                    }
                </div>
                <div class="issueList">
                    @for (error of contentErrors; track error) {
                        <div class="issueRow error" [title]="error">
                            <i class="fas fa-circle-xmark" aria-hidden="true"></i>
                            <span>{{ error }}</span>
                        </div>
                    }
                    @for (warning of contentWarnings; track warning) {
                        <div class="issueRow warning" [title]="warning">
                            <i class="fas fa-triangle-exclamation" aria-hidden="true"></i>
                            <span>{{ warning }}</span>
                        </div>
                    }
                </div>
            </div>
        }

        @if (visualsHasIssues) {
            <div class="categorySection">
                <div class="categoryHeader">
                    <i class="fas fa-image" aria-hidden="true"></i>
                    <span>{{ 'listing.validationIssues.categoryVisuals' | translate }}</span>
                    @if (visualErrors.length > 0) {
                        <span class="badgeCount error">{{ visualErrors.length }}</span>
                    }
                    @if (visualWarnings.length > 0) {
                        <span class="badgeCount warning">{{ visualWarnings.length }}</span>
                    }
                </div>
                <div class="issueList">
                    @for (error of visualErrors; track error) {
                        <div class="issueRow error" [title]="error">
                            <i class="fas fa-circle-xmark" aria-hidden="true"></i>
                            <span>{{ error }}</span>
                        </div>
                    }
                    @for (warning of visualWarnings; track warning) {
                        <div class="issueRow warning" [title]="warning">
                            <i class="fas fa-triangle-exclamation" aria-hidden="true"></i>
                            <span>{{ warning }}</span>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</div>
